import { PageBuilderWidgetModel } from "@de-trustleap/shared-models";
import { WidgetFactory } from '../utils/widgetFactory';
import { Logger } from '../utils/logger';
import { applyStyles } from '../utils/applyStyles';

export async function createElementFromWidget(
    widget: PageBuilderWidgetModel,
    isInsideRow: boolean = false
): Promise<HTMLElement | null> {
    if (!widget?.elementType) {
        Logger.error('Widget ohne elementType gefunden', widget);
        return null;
    }

    try {
        const element = await WidgetFactory.createWidget(widget, isInsideRow);

        if (!element) {
            Logger.warn('Konnte kein Element erstellen für:', widget.elementType);
            return null;
        }

        // ✅ Nur anwenden, wenn explizit erlaubt
        if ((widget as any).applyStylesExternally !== false) {
            // KEINE padding/margin hier mehr setzen!
            applyStyles(element, widget, {}); // nur ergänzende Styles, kein Spacing
        }

        Logger.debug('Widget erfolgreich erstellt', widget.elementType);
        return element;

    } catch (error) {
        Logger.error('Fehler in createElementFromWidget', error);
        return null;
    }
}
